import { ReactNode } from 'react'

import ViverseButton from '@/components/ViverseButton'
import { cn } from '@/lib/utils'

type TagPillProps = {
  label: string
  isActive: boolean
  onClick: () => void
  icon?: React.FC<React.SVGProps<SVGSVGElement>>
  buttonRef?: (node: HTMLButtonElement | null) => void
  disabled?: boolean
  trailingContent?: ReactNode
}

export default function TagPill({
  label,
  isActive,
  onClick,
  icon: Icon,
  disabled,
  buttonRef,
  trailingContent,
}: TagPillProps) {
  return (
    <ViverseButton
      ref={buttonRef}
      variant={isActive ? 'tagPillActive' : 'tagPill'}
      size="tagPill"
      className="shrink-0 whitespace-nowrap"
      onClick={onClick}
      disabled={disabled}
    >
      {Icon && (
        <Icon
          className={cn('size-3 shrink-0', isActive ? 'fill-[#131b26]' : 'fill-vive-primary-40')}
        />
      )}
      <span className="text-inherit">{label}</span>
      {trailingContent}
    </ViverseButton>
  )
}
